import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookB3Service } from './taf-book-b3.service';
import { ITAFBookB3 } from './taf-book-b3-list';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-b3/taf-book-b3.component.html',
     template: require('./taf-book-b3.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    
})

export class TAFBookB3Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK b3';
    errorMessage: string;
    tafBookB3Arr: ITAFBookB3;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookB3Service: TAFBookB3Service) {
                    
    }

    ngOnInit(): void{
        this._tafBookB3Service.getTAFBookB3()
         .subscribe(
                tafBookB3Arr => this.tafBookB3Arr = tafBookB3Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b3/taf-book-b3.component.ts
 **/